import { DEFAULT_COUNTRY } from "./constants";

const parseArgCuit = (cuit: string): string => {
  if (!cuit) return "-";

  const cuitLength = cuit.length;
  const firstDigits = cuit.slice(0, 2);
  const middleDigits = cuit.slice(2, cuitLength - 1);
  const lastDigit = cuit.slice(cuitLength - 1, cuitLength);

  return `${firstDigits}-${middleDigits}-${lastDigit}`;
};

const parseColCuit = (cuit: string): string => {
  if (!cuit) return "-";

  const cuitLength = cuit.length;
  const firstDigits = cuit.slice(0, 3);
  const middleDigits = cuit.slice(3, cuitLength - 3);
  const secondToLastDigit = cuit.slice(cuitLength - 3, cuitLength - 1);
  const lastDigit = cuit.slice(cuitLength - 1, cuitLength);

  return `${firstDigits}.${middleDigits}.${secondToLastDigit}-${lastDigit}`;
};

type TaxIdParser = Record<string, (cuit: string) => string>;

const TAX_ID_PARSERS: TaxIdParser = {
  ARG: parseArgCuit,
  COL: parseColCuit,
};

export const parseCuit = (cuit: string, country = "ARG"): string => {
  const parser = TAX_ID_PARSERS[country] || TAX_ID_PARSERS[DEFAULT_COUNTRY];
  return parser(cuit);
};
